import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { clsm } from '../utils';
import { PROFILE_COLORS } from '../constants';

const UserAvatar = ({
  avatarSrc = '',
  className = '',
  profileColor = 'default',
  size = 'lg',
  isOffline = false,
  userName = '',
  transparent = false
}) => {
  const [hasAvatarError, setHasAvatarError] = useState(false);
  const onError = useCallback(() => {
    setHasAvatarError(true);
  }, []);

  let dimensions;
  let fontSize;
  if (size === 'md') {
    dimensions = ['h-10', 'w-10'];
    fontSize = 'text-sm';
  }
  if (size === 'sm') {
    dimensions = ['h-6', 'w-6'];
    fontSize = 'text-xs';
  }
  if (size === 'lg') {
    dimensions = ['h-11', 'w-11'];
    fontSize = 'text-lg';
  }
  if (size === 'xl') {
    dimensions = ['h-[100px]', 'w-[100px]'];
    fontSize = 'text-4xl';
  }

  const avatarClassNames = clsm([
    transparent ? 'bg-transparent' : '!bg-darkMode-blue',
    transparent ? 'dark:bg-transparent' : 'dark:!bg-darkMode-blue',
    transparent ? 'hover:bg-transparent' : 'hover:bg-darkMode-blue',
    transparent ? 'hover:dark:bg-transparent' : 'hover:dark:bg-darkMode-blue',
    'shrink-0',
    'ring-2',
    'rounded-[50%]',
    'transition-all',
    'flex',
    'items-center',
    'justify-center',
    'ring-darkMode-blue',
    'dark:ring-darkMode-blue',
    dimensions,
    className
  ]);

  const getInitial = (name) => {
    if (!name) return '';
    const nameParts = name.split(' ');
    if (nameParts.length >= 2) {
      return (nameParts[0].charAt(0) + nameParts[1].charAt(0)).toUpperCase();
    }
    return name.charAt(0).toUpperCase();
  };

  return !hasAvatarError && !!avatarSrc ? (
    <img
      className={clsm([avatarClassNames, isOffline && 'grayscale'])}
      src={avatarSrc}
      onError={onError}
      alt={userName}
      draggable={false}
    />
  ) : (
    <div className={avatarClassNames}>
      <span className={clsm(['font-semibold', fontSize, 'text-white'])}>
        {userName === 'undefined undefined' ? (
          <div className="animate-pulse w-11 h-11  bg-gray-300 dark:bg-gray-600 rounded-full" />
        ) : (
          getInitial(userName)
        )}
      </span>
    </div>
  );
};

UserAvatar.propTypes = {
  avatarSrc: PropTypes.string,
  className: PropTypes.string,
  isOffline: PropTypes.bool,
  profileColor: PropTypes.oneOf([...PROFILE_COLORS, 'default', 'white']),
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  userName: PropTypes.string,
  transparent: PropTypes.bool
};

export default UserAvatar;
